import { useEffect } from 'react';

const ElevenLabsWidget = () => {
  useEffect(() => {
    // Function to load ElevenLabs widget with error handling
    const loadElevenLabsWidget = () => {
      try {
        // Check if the script is already loaded
        if (document.querySelector('script[src="https://unpkg.com/@elevenlabs/convai-widget-embed"]')) {
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
        script.async = true;
        script.defer = true; // Add defer for better performance
        script.type = 'text/javascript';
        
        script.onload = () => {
          console.log('ElevenLabs widget loaded successfully');
        };
        
        script.onerror = (error) => {
          console.log('ElevenLabs widget failed to load:', error);
        };
        
        document.head.appendChild(script);
      } catch (error) {
        console.log('Error loading ElevenLabs widget:', error);
      }
    };

    // Load after page is fully loaded to not block critical resources
    if (document.readyState === 'complete') {
      setTimeout(loadElevenLabsWidget, 2000);
    } else {
      window.addEventListener('load', () => {
        setTimeout(loadElevenLabsWidget, 2000);
      });
    }
  }, []);

  return (
    <div 
      dangerouslySetInnerHTML={{ 
        __html: '<elevenlabs-convai agent-id="agent_6401k3xx7hbhfqtbb7fwg1f7evyb"></elevenlabs-convai>' 
      }} 
    />
  );
};

export default ElevenLabsWidget;